import { ParentEventFromSearch } from "../event-page-models/parent-event-from-search";
import { numberFromString } from "./mock-utils-functions";
import { EventStatus } from "../event-page-models/event-status";
import { childEventsMock } from "./child-events.mock";

const buildFakeParentEventFromName = (name: string): ParentEventFromSearch => {
  return {
    registrationStartDate: undefined,
    brotherDiscount: false,
    closedToMembers: false,
    eventEndDate: "",
    eventEndHour: "",
    eventIndex: "",
    eventStartDate: "",
    eventStartHour: "",
    eventType: undefined,
    parentEventId: numberFromString(name, 100000),
    gainCenter1: "",
    gainCenter2: "",
    registrationEndDate: new Date(),
    parentEventCode: numberFromString(name, 100000).toString(),
    eventName: name,
    prices: "₪425, ₪385...",
    eventStatus:
      numberFromString(name, 100) > 90 ? EventStatus.Open : EventStatus.Closed,
    registeredChildren: numberFromString(name, 220),
    eventOpenTo: "מחוז ירקון",
    childEvents: [],
  };
};
const fakeEventNames = [
  " טיול אביב ארצי",
  "טיול חנוכה",
  "הפגנה",
  "רפסודיה",
  "טיול ים אל ים",
  "מיסי קן",
  "כותרת הרבה יותר ארוכה",
  "חולצת תנועה XL",
  "חולצת תנועה M",
  "פורימון",
  "מחנה פילים",
  "מחנה ד-ו",
  "מרתון",
  "עבודה בקטיף ברביד",
  "שיחה עם פסח",
  "נסיעה לירושליים",
];

export const parentEventsMocks = {
  mainMock: fakeEventNames.map((name) => buildFakeParentEventFromName(name)),
  eventsWithChildrenMock: fakeEventNames.map((name) => {
    const parent = buildFakeParentEventFromName(name);
    parent.childEvents = childEventsMock.buildFakeChildEventFromFather(parent);
    return parent;
  }),
};



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/parent-events-mocks/parent-events.mock.ts